export const environment = {
  production: false,
  apiUrl: 'https://dev.referredx.com',
  adminPortalKey: 'RX@dm!n#2025',
};
